import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { postDataLogin } from '../ApiServices/ApiService';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import LoginNav from './LoginNav';
import LoginNavLoginPage from './LoginNav_LoginPage';
import ClipboardJS from 'clipboard';

const OTPVerificationPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const email_id = searchParams.get('email_id');
    const user_id = searchParams.get('user_id');
    const test_id = searchParams.get('test_id');
    const [linkData, setLinkData] = useState('');


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (!password) {
            setError('Please Enter OTP.');
            return;
        }
        setLoading(true);
        const payload = {
            "email_id": email_id.toLowerCase(),
            "otp": password,
            "user_id": user_id,
            "test_id":test_id
        }

        try {
            await postDataLogin('demo-test/otp-verify-url', payload).then(resp => {
                if (resp.statusCode === 200) {
                    if (resp.message.toLowerCase() === 'success') {
                        setLoading(false);
                        setSuccess(resp?.info)
                        const examLink = resp?.dataJ[0].exam_link;
                        console.log("examlink",examLink)
                        setLinkData(examLink)

                    } else {
                        setLoading(false);
                        setError(resp.info);
                    }

                } else if (resp.statusCode === 500) {
                    setLoading(false);
                    setError(resp.info);
                } else {
                    setLoading(false);
                    setError('Login failed. Please check your credentials.');
                }
            }).catch((error) => {
                setLoading(false);
                setError('Login failed. Please check your credentials or Network Error');
                console.log('network error:', error);
            });
        } catch (error) {
            setLoading(false);
            setError('Login failed. Please check your credentials or Network Error');
            // Handle login error, e.g., display an error message to the user.
            console.error('Login failed', error);
        }
    };

    const [buttonText, setButtonText] = useState('Copy');

    const handleCopy = () => {
        const clipboard = new ClipboardJS('.copy-button', {
            text: function () {
                return linkData;
            },
        });

        clipboard.on('success', () => {
            setButtonText('copied')
            clipboard.destroy();
        });

        clipboard.on('error', () => {
            alert('Failed to copy link to clipboard!');
            clipboard.destroy();
        });
    };



    return (
        <>
            <LoginNavLoginPage></LoginNavLoginPage>
            <div className="outerContainer background-img-2">

                <div className='w-100'>

                    <h2 className='login-heading'><span style={{ color: 'blue' }}>Engage</span>Talent.AI - OTP Verification</h2>
                    <Container className='mainContainer'>
                        <div className='formContainer container-width'>
                            <Row >
                                <Col md={6}>
                                    {error && <Alert variant="danger" style={{textTransform:'capitalize'}}>{error}</Alert>}
                                    {success && <Alert variant="success" style={{textTransform:'capitalize'}}>{success}</Alert>}
                                    <h4 style={{ color: '#000', fontSize: 14 }}>Please Check Your Email. An OTP Has Been Sent To Your Registered Email Address.</h4>
                                    <Form className="Form" onSubmit={handleSubmit}>


                                        <Form.Group controlId="email" className='input-box margin-bottom'>
                                            <Form.Control
                                                type="email"
                                                placeholder="Enter Email"
                                                value={email_id}
                                                // onChange={(e) => setEmail(e.target.value)}
                                                className="placehold-padding"
                                                disabled
                                            />
                                        </Form.Group>

                                        <Form.Group controlId="password" className="input-box margin-bottom">
                                            <div className="input-box-wrap">
                                                <Form.Control
                                                    type={showPassword ? 'text' : 'password'}
                                                    placeholder="Enter OTP"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    className='input-box-style placehold-padding'
                                                    style={{ border: 'none' }}
                                                />
                                                <div className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </div>
                                            </div>
                                        </Form.Group>


                                        <Button variant="dark" type="submit" className="Button">
                                            Verify
                                        </Button>
                                        {loading && (
                                            <div className="spinner-overlay">
                                                <Spinner animation="border" role="status">
                                                    <span className="sr-only"></span>
                                                </Spinner>
                                            </div>
                                        )}
                                    </Form>
                                    {linkData && (
                                        <div className='m-top' style={{ display: 'flex' }}>
                                            <Form.Group style={{ width: '100%',marginRight:5 }}>
                                                <Form.Control
                                                    value={linkData}
                                                    aria-label="Generated Link"
                                                    aria-describedby="generated-link"
                                                    readOnly
                                                    style={{ background: 'white' }}
                                                />
                                            </Form.Group>
                                            <Button variant="dark" className="copy-button" onClick={handleCopy}>
                                                {buttonText}
                                            </Button>
                                        </div>
                                    )}
                                    <div >
                                        <p>Note: Please Avoid Refreshing The Test Page During The Test. If Needed, You May Be Required To Complete Up To Two Additional Tests Using This Email ID.</p>
                                    </div>


                                </Col>
                                <Col md={6} className='background-img'>

                                </Col>
                            </Row>
                        </div>
                    </Container>


                </div>
            </div>
            {/* <FooterPage></FooterPage> */}
        </>



    );
};

export default OTPVerificationPage;